'use client';

import { useSearchParams } from 'next/navigation';

import { Typography } from 'src/shared/ui/Typography';
import { useQueryLegalsGet } from 'src/dal/services/legals/legalQueries';

import styles from '../../client-component.module.css';

const POLICY_LINK_TEXT = 'политики обработки персональных данных';

export const PolicyConsentText = () => {
  const searchParams = useSearchParams();

  const legalId = searchParams.get('legal_id');

  const { data: legals } = useQueryLegalsGet();

  const legal = legals?.data?.items?.find((item) => item.id === legalId);
  const policyUrl = legal?.policyUrl;

  return (
    <Typography className={styles.policyUrl}>
      Нажимая на кнопку, Вы принимаете условия{' '}
      {policyUrl ? (
        <a className={styles.link} target="_blank" href={policyUrl} rel="noreferrer">
          {POLICY_LINK_TEXT}
        </a>
      ) : (
        POLICY_LINK_TEXT
      )}{' '}
      и даете свое согласие на:
    </Typography>
  );
};
